export enum Errors {
  COMPANY_ALREDY_EXISTS = "Firma o podanym numerze nip już istnieje w celu rejestracji oddziału dodaj oddział z poziomu interfejsu",
  WRONG_USER_CREDENTIALS = "Niepoprawny email lub hasło",
  USER_ALREDY_EXISTS = "Użytkownik o podanym adresie email już istnieje",
  UNAUTHORIZED = "Nieautoryzowany",
  UNKNOWN = "Wystąpił nieznany błąd",
  NO_RESPONSE = "Brak odpowiedzi od serwera",
  ERROR_SETTING_UP_REQUEST = "Wystąpił błąd podczas przygotowania zapytania"  
}
